import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Logo from '../assets/logo.svg';
import '../styles/base.scss'

const Header = () => (
  <nav className="pp-nav">
    <Link to="/" className="pp-nav__logo">
      <img src={Logo} height={75} width={75} alt="Paper Planes" />
      <h3 className="pp-nav__logo__heading uppercase header">Paper Planes</h3>
    </Link>
    {/* <div className="pp-nav__items">
      <Link className="pp-nav__item" to="/work">
        Work
      </Link>
      <Link className="pp-nav__item" to="/services">
        Services
      </Link>
      <Link className="pp-nav__item" to="/about">
        About
      </Link>
      <Link className="pp-nav__item" to="/contact">
        Contact
      </Link>
    </div> */}
  </nav>
)

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Paper Planes | A creative digitally led design agency"
      meta={[
        { name: 'description', content: 'A creative digitally led design agency.' },
        { 
          name: 'keywords',
          content: 'web, creative, digital, design, agency, transform, react, react native, user interface, user experience, information architecture, ui, ux'
        },
      ]}
    />
    <Header />
    <main>
      {children()}
    </main>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js